/* eslint-disable camelcase */
import React from 'react'
import Modal from '@components/TModal'
import {getAllowedCookiesFlag, setAllowedCookiesFlag} from '@utils'
import {Button} from '@retracedgmbh/ui-components-lib'
import * as Intercom from '@lib/intercom'
import {useAuth} from '@/state/auth'

const {VITE_INTERCOM_APP_ID} = import.meta.env

export default function CustomIntercomLauncher() {
  const [showConsentModal, setShowConsentModal] = React.useState(false)

  const handleClose = () => {
    setShowConsentModal(false)
  }

  const loadIntercomScript = () => {
    const script = document.createElement('script')
    script.id = 'intercom-script'
    script.src = `https://widget.intercom.io/widget/${VITE_INTERCOM_APP_ID}`
    script.async = true
    document.body.appendChild(script)

    script.onload = () => {
      const me = useAuth.getState().me
      window.Intercom('boot', {
        app_id: VITE_INTERCOM_APP_ID,
        custom_launcher_selector: '.intercom-launcher',
      })

      if (me)
        Intercom.identify(
          me?.unImpersonatedUser && Object.keys(me?.unImpersonatedUser).length ? me?.unImpersonatedUser : me
        )
    }
  }

  const handleAccept = () => {
    setAllowedCookiesFlag('true')
    setShowConsentModal(false)
    loadIntercomScript()
    setTimeout(() => {
      window.Intercom('show')
    }, 1000)
  }

  if (getAllowedCookiesFlag()) return null

  const Content = () => {
    return (
      <p className="tw:mb-4">
        We use cookies in order to provide you with our chat support service. If you accept, cookies will be set by our
        user support tool Intercom. For information on how we process your personal data, please see our
        <a
          href="https://www.retraced.com/pages/privacy-policy"
          className="tw:text-primary"
          target="_blank"
          rel="noreferrer"
        >
          {' '}
          <b>Privacy Policy</b>
        </a>
        .
      </p>
    )
  }

  return (
    <>
      <Button
        role="button"
        data-testid="custom-intercom-launcher"
        className="tw:bg-[#B4C3D5]! custom-intercom-button tw:shadow-md tw:w-[50px] tw:h-[50px] tw:rounded-full tw:fixed tw:bottom-5 tw:right-5 tw:items-center tw:flex tw:justify-center tw:z-50 tw:transition-transform tw:duration-300 tw:transform tw:hover:scale-110 tw:hover:bg-brand-900"
        onClick={() => {
          setShowConsentModal(true)
          if (!getAllowedCookiesFlag()) {
            setShowConsentModal(true)
            return
          }
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 32" width="26" height="26" fill="white">
          <path d="M28 32s-4.714-1.855-8.527-3.34H3.437C1.54 28.66 0 27.026 0 25.013V3.644C0 1.633 1.54 0 3.437 0h21.125c1.898 0 3.437 1.632 3.437 3.645v18.404H28V32zm-4.139-11.982a.88.88 0 00-1.292-.105c-.03.026-3.015 2.681-8.57 2.681-5.486 0-8.517-2.636-8.571-2.684a.88.88 0 00-1.29.107 1.01 1.01 0 00-.219.708.992.992 0 00.318.664c.142.128 3.537 3.15 9.762 3.15 6.226 0 9.621-3.022 9.763-3.15a.992.992 0 00.317-.664 1.01 1.01 0 00-.218-.707z"></path>
        </svg>
      </Button>

      <Modal
        scrollType="content"
        size="sm"
        title=""
        onCancel={handleClose}
        okButtonProps={{
          title: 'Accept',
          onClick: handleAccept,
          'data-testid': 'accept-cookie-modal-btn',
        }}
        cancelButtonProps={{
          title: 'Decline',
          'data-testid': 'decline-cookie-modal-btn',
        }}
        onRequestClose={handleClose}
        isVisible={showConsentModal}
      >
        <Content />
      </Modal>
    </>
  )
}
